export const INCOGNITO_CART_CONSTANTS = {
    COLORS: {
        INCOGNITO_NUDGE_BG: "#3B1F62",
        WHITE: "#ffffff",
        LIGHT_CONTENT: "lightContent",
        DEFAULT: "default",
    },
};
